<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 491.494 491.494" xml:space="preserve">
<g>
	<g>
		<path d="M476.419,53.917l-38.855-38.86c-20.06-20.05-52.705-20.06-72.775,0l-126.295,126.3c-9.72,9.71-15.07,22.64-15.07,36.38
			c0,13.75,5.35,26.67,15.07,36.39l14.48-14.48c-5.85-5.85-9.07-13.63-9.07-21.91c0-8.27,3.22-16.05,9.07-21.9l126.295-126.3
			c12.08-12.08,31.735-12.08,43.815,0l38.855,38.86c5.85,5.85,9.075,13.63,9.075,21.91c0,8.27-3.22,16.05-9.075,21.9l-126.29,126.3
			c-11.71,11.7-32.115,11.7-43.815,0l-14.48,14.48c9.715,9.72,22.64,15.08,36.385,15.08s26.67-5.36,36.39-15.08l126.29-126.3
			c9.72-9.71,15.075-22.63,15.075-36.38S486.139,63.638,476.419,53.917z"/>
	</g>
</g>
<g>
	<g>
		<path d="M252.974,277.368l-14.48,14.48c5.85,5.85,9.07,13.63,9.07,21.91c0,8.27-3.22,16.05-9.07,21.9l-126.295,126.3
			c-12.08,12.08-31.735,12.08-43.815,0l-38.855-38.86c-12.08-12.08-12.08-31.74,0-43.82l126.29-126.29
			c11.71-11.7,32.115-11.7,43.815,0l14.48-14.48c-9.715-9.72-22.64-15.08-36.385-15.08s-26.67,5.36-36.39,15.08l-126.29,126.29
			c-20.065,20.07-20.065,52.71,0,72.78l38.855,38.86c10.035,10.03,23.21,15.04,36.39,15.04c13.175,0,26.355-5.01,36.385-15.04
			l126.295-126.3c9.72-9.71,15.07-22.64,15.07-36.38C268.044,300.008,262.694,287.088,252.974,277.368z"/>
	</g>
</g>
<g>
	<g>
		
			<rect x="149.549" y="235.505" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -101.7958 245.7455)" width="192.358" height="20.48"/>
	</g>
</g>
</svg>